"use client";

import {
  AGE_GROUP_CHANGED_EVENT,
  AGE_GROUP_KEY,
  isGrownupFromStorage,
} from "@/lib/age-group/store";
import { useEffect, useState } from "react";

/**
 * Client-only hook that returns whether the current visitor is a grownup.
 * Defaults to `false` until the first client effect runs.
 */
export function useIsGrownup(): boolean {
  const [isGrownup, setIsGrownup] = useState(false);

  useEffect(() => {
    const refresh = () => setIsGrownup(isGrownupFromStorage());

    refresh();

    const onAgeGroupChanged = () => refresh();
    const onStorage = (e: StorageEvent) => {
      if (e.key === AGE_GROUP_KEY) refresh();
    };

    window.addEventListener(AGE_GROUP_CHANGED_EVENT, onAgeGroupChanged);
    window.addEventListener("storage", onStorage);

    return () => {
      window.removeEventListener(AGE_GROUP_CHANGED_EVENT, onAgeGroupChanged);
      window.removeEventListener("storage", onStorage);
    };
  }, []);

  return isGrownup;
}
